import styled from "styled-components";
import React from "react";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 110px;
  width: 100%;
  padding: 16.5px 19px;
  background-color: ${props => props.theme.color.site_main_color};
  border: 2px solid ${props => props.theme.color.green_100};
  border-radius: 6px;
  margin-bottom: 10px;
`;
const LeaderImageBox = styled.div`
`;
const LeaderImage = styled.img`
  max-height: 90px;
  border-radius: 6px;
`;
const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  flex: 1;
`;
const RowBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & + & {
    margin-top: 12px;
  }
`;
const TeamBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 36px;
  padding: 0 10px;
  background-color: ${props => props.theme.color.green_200};
  border-radius: 6px;
  margin-right: 10px;
`;
const TeamSpan = styled.span`
  color: ${props => props.theme.color.green_100};
  font-size: 24px;
  font-weight: bold;
`;
const LeaderSpan = styled.span`
  font-size: 24px;
  font-weight: bold;
  color: ${props => props.theme.color.green_100};
  text-transform: capitalize;

`;
const CheerBox = styled.div`
  background-color: ${props => props.theme.color.white_200};
  width: 100%;
  height: 36px;
  padding: 0 10px;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const CheerSpan = styled.span`
  color: ${props => props.theme.color.dark_200};
  font-size: 14px;
  font-weight: 500;
`;
const EventComment = ({cheer, team}) => {
    return (
        <Wrapper>
            <LeaderImageBox>
                <LeaderImage src={`${process.env.REACT_APP_ROOT_IMG}assets/team_logos/${team}.png`}
                             width={112}
                             alt={''}/>
            </LeaderImageBox>
            <InfoBox>
                <RowBox>
                    <LeaderSpan>{team}</LeaderSpan>
                </RowBox>
                <RowBox>
                    <CheerBox>
                        <CheerSpan>
                            {cheer}
                        </CheerSpan>
                    </CheerBox>
                </RowBox>
            </InfoBox>
        </Wrapper>
    );
}

export default EventComment